import { useCallback, useEffect, useState } from "react";

/**
 * @param {HTMLElement | null} anchorEl
 * @returns {boolean}
 */
const isAnchorVisible = (anchorEl) => {
  if (!anchorEl || typeof window === "undefined") {
    return false;
  }

  const rect = anchorEl.getBoundingClientRect();
  return (
    rect.width > 0 &&
    rect.height > 0 &&
    rect.bottom > 0 &&
    rect.right > 0 &&
    rect.top < window.innerHeight &&
    rect.left < window.innerWidth
  );
};

/**
 * @param {HTMLElement | null} anchorEl
 * @returns {boolean}
 */
export const useVisibleAnchor = (anchorEl) => {
  const [isVisible, setIsVisible] = useState(() => isAnchorVisible(anchorEl));

  const syncVisibility = useCallback(() => {
    setIsVisible(isAnchorVisible(anchorEl));
  }, [anchorEl]);

  useEffect(() => {
    syncVisibility();

    if (!anchorEl) {
      return undefined;
    }

    const onViewportChange = () => {
      syncVisibility();
    };

    window.addEventListener("resize", onViewportChange);
    window.addEventListener("scroll", onViewportChange, true);

    const retryTimer = window.setTimeout(syncVisibility, 150);

    return () => {
      window.removeEventListener("resize", onViewportChange);
      window.removeEventListener("scroll", onViewportChange, true);
      window.clearTimeout(retryTimer);
    };
  }, [anchorEl, syncVisibility]);

  return isVisible;
};
